<div class="p-grid">

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Unified platform for operational services "
  >
  This is Operations Portal which is used by customer service agents to resolve end customer queries and issues of the B2C application.
   My Role is <b> Team Lead </b> where backend API services is developed using <b>Node.js , Express and GraphQL </b> .
    The front end is developed using <b>React.js</b> and is a micro-frontend.
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Employee Management System "
  >
  This is an Employee management application which has different components which includes employee talent  management application, Internal job transfer application  , etc .
   My Role is <b> Team Lead </b> where backend API services is developed using <b>Java Spring Boot , Python and PostgreSQL </b> .
    The front end is developed using <b>React.js</b>.
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Purchase Squad  "
  >
  This is a Node.js microservice which provides api to the beauty products retail E-commerce application. 
  My Role is to develop microservice for basket management using <b>Node.js (express.js)</b>.
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Infinity – Fulfillment Platform  "
  >
  This is Fulfilment Portal which is used by store colleagues for online orders management ,Picking information ,Colleague performance details.
   My Role is Application developer where frontend is <b>React.js, Styled component </b> and backend is <b>Node.js (express.js) </b>.
   I have also involved in CI/CD process which involves Building <b>Docker Image</b> and Deployment of app in <b>Azure</b> cloud . 
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Managed printer Services "
  >
    This is an Printer service provider Application to manage print services and
    onboarding of printer devices. My Role is an
    <b>Application developer</b> where front end is <b>React.js</b> and the
    backend is <b>Node.js(express.js)</b> and API style is
    <b>GraphQL.</b>
  </p-card>

  <p-card class="p-col-12" styleClass="card-container" header="CCE">
    This is a <b>Health care application </b>which is used for B2B clients,
    where services of business apps can be used by other business apps.My Role
    is

    <b>Application Lead</b> where front end is <b>Angular</b> and the backend is
    <b>Node.js(express.js)</b> for BFF and API style is <b>REST.</b>.I have also
    involved in Creating CI/CD Pipeline which involves Building
    <b>Docker Image</b> and Deployment of app in <b>Azure DevOps</b>.Used
    <b>VSTS</b>
    for project management
  </p-card>

  <p-card class="p-col-12" styleClass="card-container" header="MobileEBPP">
    This is a <b>Telecom provider Web/Mobile application </b> used to provide a
    platform for the subscribers to view/manage their subscription.This app is
    implemented using <b>Microservices architecture</b> style. My role is a
    <b>Module lead </b> where front end is <b>Angular </b> and the backend is
    <b>Node.js (Hapi.js)</b>.I have experience implementing SSO using
    <b>JWT</b> and related libraries.i have used <b>Seneca</b> framework for
    implementing microservices.<b>ELK and Filebeat </b> is used to monitor
    microservice app logs.<b>Redis</b> is used as Caching.<b>Mongodb</b> is used
    for validating user for testing tools.<b>Docker</b> is used for containers
    .The <b>cloud</b> deployment is done in <b>Microsoft Azure</b>
  </p-card>

  <p-card class="p-col-12" styleClass="card-container" header="WebEBPP">
    This is a <b>Telecom provider web application </b> used to provide a
    platform for the subscribers to view their subscription details.This is the
    previous version of MobileEBPP .This app is implemented using
    <b>Monolithic architecture</b> style. My role is a
    <b>Application developer </b> where front end is <b>Angular </b> and the
    backend is <b>Node.js (Hapi.js)</b>.I have experience implementing SSO using
    <b>JWT</b> and related libraries.
  </p-card>

  <p-card class="p-col-12" styleClass="card-container" header="PPM">
    This is a <b>Health care application</b> which is used for B2C and B2B
    clients, Where B2B clients can enroll a pricing and get paid for the
    services and B2C clients can enroll for Services and paid amount for
    provided services My role is <b>React developer </b> and unit testing using
    <b>Karma/Jasmine</b>.
  </p-card>

  <p-card class="p-col-12" styleClass="card-container" header="Belgacom">
    This is a <b>Telecom provider e-commerce application </b> used to provide a
    platform for the customers to avail services through multiple channels such
    as services via mobile , kiosks , online ,etc.My role is
    <b>Full stack developer</b> where Front end is <b>FTL and Bootstrap</b> and
    backend is <b>Java , Servlet</b>.Software project management is done using
    <b>Maven</b>
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Resource IG Performance"
  >
    This is a <b>Data visualization application </b> used to visualize how the
    particular Industry group is functioning. My role is
    <b>Application developer</b> and responsiblity is to create
    <b>Data visualization dashboard</b> The dashboard is designed to be
    responsive, and the targets are Mobiles and Tablets. The Front end is
    <b>React.js</b> and <b>Node.js</b> is used as middleware to serve
    statistical data to frontend .<b>Bootstrap 3</b> is used for responsive
    design
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Image Management Browser"
  >
    This is a <b>Healthcare provider application </b> involves a Swing based
    stand-alone application facilitating radiologist to examine and handle a
    patient’s image scan providing flexibility to navigate, modify and transfer
    images. My role is <b>Java Application developer</b> using Netbeans RCP
    platform and technologies used are <b>OSGI and Apache Karaf</b> Unit testing
    is done using <b>Junit</b>
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Cisco Transport Controller"
  >
    This is a <b>Network device application</b> which is a tool used as an
    element manager interface for fault management, Configuration and
    provisioning across network. My role is a <b>Application developer</b> using
    <b>Java</b>.I have also involed in <b>performance analysis</b> of the
    developed application using
    <b>JProfiler</b>
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Lloyds Foundation Desktop"
  >
    This is a <b>Banking application</b> which is used to onboard mulitple
    banking products in a single platform. My role is
    <b>Application lead</b> and my responsibilty is to gather
    <b>Non-functional Requirements</b> and give required input to the
    performance team for them to produce reports. I have also involed in
    <b>Penetration testing</b> where i got exposed to
    <b>OWASP security guidelines</b>.I got exposed to <b>HP LoadRunner</b> tool
    to run performance scripts.
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="Verisat DVB Hub and terminal simulator"
  >
    This is a <b>DVB based simulation software</b> which has multiple products
    which acts as a simulator to test the broadcasting hub and the reciever
    terminal . My role is <b>product developer</b> and my responsibilty is to
    develop DVB Terminal product simulator using <b>Java,JNI,RMI</b>
  </p-card>

  <p-card
    class="p-col-12"
    styleClass="card-container"
    header="MiniCPE Product Development "
  >
    This is <b>Network Configuration tool</b> which is used to manage the
    network devices.<b>SNMP Protocal</b> is used. This tool has two types of
    interface to configure the device(CLI,HTTPUI).My role is
    <b>HTTP UI developer</b>
    for the SNMP agent configuration from the Remote desktop using HTML,CSS and
    Javascript.
  </p-card>
</div>
